import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Category} from "projects/store/src/app/enums";





@Component({
  selector: 'app-sales-product',
  templateUrl: './sales-product.component.html'
})
export class SalesProductComponent{
  categoryCode: string;
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();


  constructor(private route: ActivatedRoute) {
    this.categoryCode = this.route.snapshot.params['category_code'];

  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  onGotoStep(navigationData: { flowCode: string; stepCode: string }) {
    this.gotoStepEvent.emit(navigationData );
  }

  protected readonly Category = Category;


}
